{
  "longPressMessage": "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
}
